const LIMIT = 1000;

export function formatCount(count: number, locale = window.navigator.language) {
  const formatter = new Intl.NumberFormat(locale);

  return count > LIMIT
    ? `${formatter.format(LIMIT)}+`
    : formatter.format(count);
}
